<template>
  <div>
    <h3 class="mg-t-less pd-t-3">หลักสูตร {{ title }}</h3>
    <p class="text-font-14">
      เวลาเรียนทั้งหมด {{ time }} ชั่วโมง
      <span class="mg-l-5 color-gray-lighter">•</span>
      <SocialShare
        :courseName="title"
        :message="`หลักสูตร ${title}`"
        :urlCopy="`course/detail?courseId=${id}`"
      />
    </p>

    <div class="pd-b-4">
      <a
        v-for="(item, index) in fileList"
        :key="index"
        :href="`${urlCouse}${id}/${item.file}`"
        class="color-primary"
        target="blank"
        style="display: block"
      >
        <i
          :class="`fas ${getFileIcon(item.type).name} text-font-16`"
          :style="`color:${getFileIcon(item.type).color}`"
        ></i>
        <span class="text-font-12 pd-l-5">{{ item.default }}</span>
      </a>
    </div>
    <div v-if="!user || user.role == 0">
      <el-button
        v-if="status == 0"
        @click="user ? registerCourse() : $router.push(`/signup`)"
        :type="
          !user && status == 0 && Date.now() >= new Date(open)
            ? 'success'
            : 'primary'
        "
        round
        class="pd-x-1 button-status"
        :loading="loading"
      >
        <span v-if="!user && status == 0 && Date.now() >= new Date(open)">
          เปิดเรียนออนไลน์แล้ว
        </span>
        <span v-else>
          ลงทะเบียนเรียน เริ่มเรียน {{ new Date(open) | dateThNumber }}
        </span>
      </el-button>

      <el-button
        v-if="status == 1 && Date.now() <= new Date(open)"
        type="success button-status"
        round
        class="pd-x-1"
        >อนุมัติการเรียนออนไลน์ เริ่มเรียน
        {{ new Date(open) | dateThNumber }}</el-button
      >

      <el-button
        @click="
          $router.push(
            subject.topics.length > 0
              ? `/course/learn?courseId=${id}&subjectId=${subject.subjectId}&topicId=${subject.topics[0]._id}`
              : `/course/learn?courseId=${id}&subjectId=${subject.subjectId}`
          )
        "
        v-if="
          status == 1 && Date.now() >= new Date(open) && subjects.length > 0
        "
        type="success button-status"
        round
        class="pd-x-1"
        >เรียนออนไลน์</el-button
      >

      <el-button
        v-if="
          status == 1 && Date.now() >= new Date(open) && subjects.length == 0
        "
        type="success button-status"
        round
        class="pd-x-1 cursor-auto"
        >รออัปเดทรายวิชา</el-button
      >

      <el-button
        v-if="status == 2"
        type="warning  "
        round
        class="pd-x-1 cursor-auto button-status"
        >รออนุมัติการเรียนออนไลน์</el-button
      >
      <el-button
        v-if="status == 3"
        type="danger"
        round
        class="pd-x-1 cursor-auto light button-status"
        >ไม่อนุมัติ</el-button
      >
    </div>
    <div v-if="user && (user.role == 60 || user.role == 80)">
      <el-button
        @click="
          !subject
            ? null
            : $router.push(
                subject.topics.length > 0
                  ? `/course/learn?courseId=${id}&subjectId=${subject.subjectId}&topicId=${subject.topics[0]._id}`
                  : `/course/learn?courseId=${id}&subjectId=${subject.subjectId}`
              )
        "
        :type="subject ? 'secondary' : 'success'"
        round
        class="pd-x-1 button-status"
      >
        <span>
          {{ subject ? "ดูข้อมูลหลักสูตร" : "รออัปเดทรายวิชา" }}
        </span>
      </el-button>
    </div>
    <el-dialog
      title="กรุณาติดต่อเจ้าหน้าที่"
      :visible.sync="dialogContact"
      class="text-center padding-top-10"
    >
      <el-image :src="require('@/assets/1602779109TAT_Group.svg')"></el-image>
    </el-dialog>
  </div>
</template>

<script>
import { getFileIcon } from "@/service/file";
import SocialShare from "../social/SocialShare";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    SocialShare,
  },
  props: {
    id: {
      type: String,
      default() {
        return "";
      },
    },
    title: {
      type: String,
      default() {
        return "";
      },
    },
    time: {
      type: String,
      default() {
        return "";
      },
    },
    status: {
      type: Number,
      default() {
        return 0;
      },
    },
    fileList: {
      type: Array,
      default() {
        return [];
      },
    },
    open: {
      type: String,
      default() {
        return "";
      },
    },
    subjects: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user() {
      return this.$store.state.user;
    },
  },
  data() {
    return {
      loading: false,
      urlCouse: process.env.VUE_APP_BASE_URL_FILE_COURSE,
      subject: "",
      dialogContact: false,
    };
  },
  mounted() {
    if (this.subjects) {
      this.subject = this.getSubject();
    }
  },
  watch: {
    subjects() {
      this.subject = this.getSubject();
    },
  },
  methods: {
    getSubject() {
      if (this.subjects.length > 0) {
        let filter = this.subjects.filter(
          (filter) =>
            Date.now() >= new Date(filter.durationTime.open).getTime() &&
            Date.now() <= new Date(filter.durationTime.close).getTime()
        );

        if (filter.length > 0) {
          return filter[0];
        } else {
          return this.subjects[0];
        }
      } else {
        return "";
      }
    },
    registerCourse() {
      this.loading = true;
      let obj = {
        courseId: this.id,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`register`, obj)
        .then((res) => {
          if (res.data.success) {
            this.$emit("fetchCourseStatus");
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("registerCourse error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
  },
};
</script>
